// Self-contained API layer for the Feature Requests page. The server proxies these to
// the central admin-portal hub; voter/requester identity is attached server-side.
import axios from '../../Util/axiosConfig';
import { baseUrl } from '../../Contants';

export const getFeatureRequests = () =>
  axios.get(`${baseUrl}/api/feature-requests`);

export const getMyFeatureRequests = () =>
  axios.get(`${baseUrl}/api/feature-requests/mine`);

export const submitFeatureRequest = (requestDetails) =>
  axios.post(`${baseUrl}/api/feature-request/create`, {
    request_details: requestDetails,
  });

export const voteFeatureRequest = (featureRequestId, vote) =>
  axios.post(`${baseUrl}/api/feature-request/${featureRequestId}/vote`, {
    vote,
  });

export const getFeatureRequestComments = (featureRequestId) =>
  axios.get(`${baseUrl}/api/feature-request/${featureRequestId}/comments`);

export const addFeatureRequestComment = (
  featureRequestId,
  comment,
  parentCommentId = null
) =>
  axios.post(`${baseUrl}/api/feature-request/${featureRequestId}/comment`, {
    comment,
    parent_comment_id: parentCommentId,
  });

export const updateFeatureRequestComment = (featureRequestId, commentId, comment) =>
  axios.post(
    `${baseUrl}/api/feature-request/${featureRequestId}/comment/${commentId}/update`,
    { comment }
  );

export const deleteFeatureRequestComment = (featureRequestId, commentId) =>
  axios.post(
    `${baseUrl}/api/feature-request/${featureRequestId}/comment/${commentId}/delete`
  );
